import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Fragment } from "react";
import { Form } from "react-bootstrap";
import AssignPeriodModal from "../Modals/AssignPeriodModal";
import config from '../../../config';
import { showToast } from "../../../utils/toast";
import { useDispatch, useSelector } from 'react-redux';
import { fetchLogo  } from '../../../store/actions/logoActions';

export default function Timetable() {
  const modalRef = useRef();  
  const [classes, setClasses] = useState([]);
  // const [selectedClass, setSelectedClass] = useState("");
  const [school, setSchool] = useState(null);
  const [logo, setLogo] = useState("");   
  
  const [gradeId, setGradeId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [selectedClass, setSelectedClass] = useState(""); // derived class_id

  const [timetableData, setTimetableData] = useState([]);
  const [classTeacher, setClassTeacher] = useState("");
  const [periods, setPeriods] = useState([]);
  const dispatch = useDispatch();
  const { logoUrl } = useSelector((state) => state.logo);

  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
  //academic year 
  const [academicYear] = useState(
    `${new Date().getFullYear()}-${new Date().getFullYear() + 1}`
  );

  useEffect(() => {
      dispatch(fetchLogo());
    }, [dispatch]);

  useEffect(() => {
    fetchSchoolDetails();
  }, []);

  //
  const uniqueGrades = [
    ...new Map(
      classes.map(c => [c.grade_id, c])
    ).values()
  ];

  //
  const availableSections = gradeId
    ? classes.filter(c => c.grade_id == gradeId)
  : [];

  //
  const handleGradeChange = (e) => {
    const selected = e.target.value;
    setGradeId(selected);
    setSectionId("");
    setSelectedClass("");
  };

  //section select 
  const handleSectionSelect = (secId) => {
    setSectionId(secId);

    const found = classes.find(
      c =>
        c.grade_id == gradeId &&
        c.section_id == secId
    );

    setSelectedClass(found?.class_id || "");
  };

  const handlePrint = () => {

      if (!selectedClass) {
        showToast("warning", "Please select a class before printing.");
        return;
      }

      const tableContent = document.querySelector(".timetable-print").innerHTML;

      const selectedClassObj = classes.find(
        (c) => c.class_id === selectedClass
      );

      const className = selectedClassObj?.grade_name || "";
      const section = selectedClassObj?.section_name || "";
      const year = academicYear;

      const documentTitle = `${className}_${section}_${year}`;

      const printWindow = window.open("", "", "width=1200,height=800");

      printWindow.document.write(`
        <html>
          <head>
            <title>${documentTitle}</title>
            <style>
              @page {
                size: A4 landscape;
                margin: 10mm;
              }

              body {
                font-family: Arial, sans-serif;
                position: relative;
              }

              .watermark {
                position: fixed;
                top: 50%;
                left: 50%;
                width: 500px;
                height: 500px;
                background-image: url('${logoUrl}');
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
                opacity: 0.05;
                transform: translate(-50%, -50%);
                z-index: 0;
              }

              .content {
                position: relative;
                z-index: 1;
              }

              table {
                width: 100%;
                border-collapse: collapse;
                text-align: center;
                font-size: 12px;
              }

              th, td {
                border: 1px solid #000;
                padding: 6px;
              }

            </style>
          </head>
          <body>

            <div class="watermark"></div>

            <div class="content">

              <div style="text-align:center; margin-bottom:15px;">
                <img 
                  src="${logoUrl}" 
                  style="width:70px; height:70px; display:block; margin:0 auto 8px auto;" 
                />
                <div style="font-size:18px; font-weight:bold;">
                  ${school?.school_name || ""}
                </div>
                <div style="font-size:13px;">
                  ${school?.school_address || ""}, 
                  ${school?.city || ""}, 
                  ${school?.district || ""}, 
                  ${school?.state || ""}
                </div>
                <div>
                  Class: ${className} - ${section}
                </div>
                <div>
                  Academic Year: ${year}
                </div>
              </div>

              ${tableContent}

            </div>

          </body>
        </html>
      `);

      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };

  const fetchSchoolDetails = async () => {
    try {
      const res = await axios.get(
        `${config.apiBaseUrl}/school/get-school-details.php`
      );

      if (res.data.status === "success") {
        setSchool(res.data.data);
      }

      // Fetch logo separately if needed
      const logoRes = await axios.get(
        `${config.apiBaseUrl}/school/get-logo.php`
      );

      if (logoRes.data.success) {
        setLogo(logoRes.data.logo);
      }

    } catch (err) {
      console.error("Failed to load school info");
    }
  }; 

  useEffect(() => {
    fetchClasses();
  }, []);

  useEffect(() => {
    if (selectedClass) {
      fetchTimetable();
    }
  }, [selectedClass]);

  useEffect(() => {
    fetchPeriods();
  }, [academicYear]);

  const fetchPeriods = async () => {
    try {
      const res = await axios.get(
        `${config.apiBaseUrl}/academic/get-periods.php`,
        {
          params: { academic_year: academicYear },
        }
      );

      if (res.data.success) {
        setPeriods(res.data.data);
      }
    } catch (err) {
      console.error("Failed to load periods");
    }
  };

  const fetchClasses = async () => {
    try {
      const res = await axios.get(
        `${config.apiBaseUrl}/grades/classes.php?action=list`
      );

      if (Array.isArray(res.data)) {
        setClasses(res.data);
      } else if (res.data.success) {
        setClasses(res.data.data);
      }

    } catch (err) {
      console.error("Failed to load classes");
    }
  };

  const fetchTimetable = async () => {
    try {
      const res = await axios.get(
        `${config.apiBaseUrl}/academic/get-timetable.php`,
        {
          params: {
            class_id: selectedClass,
            academic_year: academicYear,
          },
        }
      );

      if (res.data.success) {
        setTimetableData(res.data.data);
        setClassTeacher(res.data.class_teacher);
      }
    } catch (err) {
      console.error("Failed to load timetable");
    }
  };

  const getCellData = (day, period) => {
    return timetableData.find(
      (row) => row.day_of_week === day && row.period_number === period
    );
  };

  const handleCellClick = (day, period) => {
        if (period === 1) return;

        if (!selectedClass) {
            showToast("warning", "Please select a class first");
        return;
    }
    modalRef.current.openModal(day, period);
  };

  useEffect(() => {
    if (logoUrl) {
      document.documentElement.style.setProperty(
        "--timetable-logo",
        `url(${logoUrl})`
      );
    }
  }, [logoUrl]);

  return (
    <Fragment>
      <div className="row">
        <div className="col-xl-12">

          {/* HEADER (Hidden in Print) */}
          <div className="d-flex align-items-end gap-3">

          {/* Class Dropdown */}
          <div>
            <Form.Label>Class</Form.Label>
            <Form.Select
              size="sm"
              style={{ width: 200 }}
              value={gradeId}
              onChange={handleGradeChange}
            >
              <option value="">Select Class</option>

              {uniqueGrades.map(g => (
                <option key={g.grade_id} value={g.grade_id}>
                  Class-{g.grade_name}
                </option>
              ))}
            </Form.Select>
          </div>

          {/* Section Radios */}
          {gradeId && (
            <div>
              <Form.Label>Section</Form.Label>

              <div className="d-flex gap-3 mt-1">
                {availableSections.map(sec => (
                  <Form.Check
                    key={sec.section_id}
                    type="radio"
                    name="section"
                    label={sec.section_name}
                    checked={sectionId == sec.section_id}
                    onChange={() => handleSectionSelect(sec.section_id)}
                  />
                ))}
              </div>
            </div>
          )}

          <button
            className="btn btn-primary btn-sm"
            onClick={handlePrint}
          >
            Print Timetable
          </button>

        </div>

          {/* PRINTABLE AREA START */}
          <div className="timetable-print">

            {/* TIMETABLE GRID */}
            <div className="table-responsive">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Day / Period</th>
                    {periods.map((period) => (
                      <th key={period.period_number}>
                        {period.period_name}
                        <div style={{ fontSize: 11 }}>
                          {period.start_time.slice(0, 5)} - {period.end_time.slice(0, 5)}
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {days.map((day) => (
                    <tr key={day}>
                      <td><strong>{day}</strong></td>

                      {periods.map((periodObj) => {
                        const period = periodObj.period_number;
                        const isBreak = periodObj.is_break === "Yes";
                        const cell = getCellData(day, period);

                        return (
                          <td
                            key={period}
                            style={{
                              cursor: isBreak || period === 1 ? "not-allowed" : "pointer",
                              backgroundColor: isBreak ? "#f0f0f0" : "#ffffff",
                            }}
                            onClick={() => {
                              if (!isBreak && period !== 1)
                                handleCellClick(day, period);
                            }}
                          >
                            {isBreak ? (
                              <strong>Break</strong>
                            ) : period === 1 ? (
                              <div>
                                <strong>{classTeacher || "-"}</strong>
                                <div style={{ fontSize: 12 }}>Attendance</div>
                              </div>
                            ) : cell ? (
                              <div>
                                <strong>{cell.subject_name}</strong>
                                <div style={{ fontSize: 12 }}>
                                  {cell.teacher_name}
                                </div>
                              </div>
                            ) : (
                              <span className="text-muted">No Period</span>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

          </div>
          {/* PRINTABLE AREA END */}

        </div>
      </div>

      {/* Modal -> add period */}
      <AssignPeriodModal
        ref={modalRef}
        classId={selectedClass}
        academicYear={academicYear}
        onSuccess={fetchTimetable}
      />
    </Fragment>
  );
}